import { useEffect, useState } from 'react';

export const useIsTouchscreen = (): boolean => {
	const [isTouchscreen, setIsTouchscreen] = useState(() => window.matchMedia('(pointer: coarse)').matches);

	useEffect(() => {
		const query = window.matchMedia('(pointer: coarse)');
		const handler = (e: MediaQueryListEvent) => setIsTouchscreen(e.matches);
		query.addEventListener('change', handler);
		return () => query.removeEventListener('change', handler);
	}, []);

	return isTouchscreen;
};
